export default __webpack_public_path__ + "static/Entenda0108-0d7b7945337d2c68db1977a6815bc8d2.jpg";